import Joi from "joi";

export const prioritySchema = Joi.object({
  title: Joi.string().min(2).label("Title"),
  isDefault: Joi.boolean().label("Is Default"),
});
